import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../News/News.css";

const News = () => {

  const [newsItems, setNewsItems] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const visibleCards = 3;


  /* FETCH NEWS FROM MYSQL */

  const loadNews = async () => {
    try {
      const res = await axios.get("/api/news");
      setNewsItems(res.data);
    } catch (err) {
      console.error("Error loading news:", err);
    }
  };

  useEffect(() => {
    loadNews();
  }, []);


  /* DATE FORMATTER */

  // Convert DD-MM-YYYY → "Saturday, April 05, 2026"
const formatIndianDate = (dateStr) => {

  if (!dateStr) return "";

  const cleanDate = dateStr.replace(/\//g, "-").trim();

  const parts = cleanDate.split("-");

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // JS months start from 0
  const year = parseInt(parts[2], 10);

  const date = new Date(year, month, day);

  return date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
};

  const startAutoSlide = useCallback(() => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) =>
        prev + visibleCards >= newsItems.length ? 0 : prev + visibleCards
      );
    }, 4000);
  }, [newsItems]);


  const stopAutoSlide = () => {
    clearInterval(intervalRef.current);
  };


  useEffect(() => {
    if (newsItems.length > 0) {
      startAutoSlide();
    }
    return () => stopAutoSlide();
  }, [newsItems, startAutoSlide]);


  /* CAROUSEL VISIBLE NEWS */

  const visibleNews = newsItems.slice(
    currentIndex,
    currentIndex + visibleCards
  );

  if (visibleNews.length < visibleCards && newsItems.length > 0) {

    visibleNews.push(
      ...newsItems.slice(0, visibleCards - visibleNews.length)
    );

  }


  return (
    <section className="news-section">

      <div className="news-wrapper">

        {/* Header */}

        <div className="news-header text-center">

          <h2 className="news-title">LATEST NEWS</h2>

          <p className="news-subtitle">
            Stay updated with our latest announcements and activities
          </p>

        </div>


        {/* Carousel */}

        <div
          className="news-carousel"
          onMouseEnter={stopAutoSlide}
          onMouseLeave={startAutoSlide}
        >

          <div className="row">

            {visibleNews.map((news) => (

              <div className="col-lg-4 col-md-6" key={news.id}>

                <div className="news-card">

                  <div className="news-img">

                    <img
                      src={`${BASE_URL}/uploads/news/${news.image}`}
                      alt={news.title}
                    />

                  </div>


                  <div className="news-content">

                    <h5>{news.title}</h5>

                    <p>
                      {(news.description || "").substring(0,120)}...
                    </p>


                    <div className="news-footer">

                      <span className="news-date">

                        <i className="bi bi-calendar-event"></i>{" "}
                        {formatIndianDate(news.news_date)}

                      </span>


                      <button
                        className="btn btn-success btn-sm"
                        data-bs-toggle="modal"
                        data-bs-target="#newsModal"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedNews(news);
                        }}
                      >
                        Read More...
                      </button>

                    </div>

                  </div>

                </div>

              </div>

            ))}

          </div>

        </div>

      </div>



{/* MODAL */}


<div className="modal fade" id="newsModal">

  <div className="modal-dialog modal-xl modal-dialog-centered">

    <div className="modal-content news-modal">

      {selectedNews && (

        <>

          <div className="modal-header news-modal-header">

            <h5 className="modal-title">
              {selectedNews.title}
            </h5>

            <button
              type="button"
              className="btn btn-secondary ms-auto"
              data-bs-dismiss="modal"
            >
              Close
            </button>

          </div>


          <div className="modal-body">

            <div className="row g-4">

              {/* IMAGE */}

              <div className="col-lg-5">

                <div className="news-modal-img-box">

                  <img
                    src={`${BASE_URL}/uploads/news/${selectedNews.image}`}
                    alt=""
                    className="img-fluid"
                  />

                </div>

              </div>


              {/* CONTENT */}

              <div className="col-lg-7">

                <div className="news-modal-content">

                  <p className="news-modal-text">
                    {selectedNews.description}
                  </p>


                  <div className="news-modal-date">

                    <i className="bi bi-calendar-event"></i>{" "}
                    {formatIndianDate(selectedNews.news_date)}

                  </div>

                </div>

              </div>

            </div>

          </div>

        </>

      )}

    </div>

  </div>

</div>

    </section>
  );
};

export default News;